<template>
<div class="card card_backgroundGray">
    <img v-if="item.image" :src="item.image" :alt="item.imageAltText" :srcset="item.imageSrcSet" :sizes="item.imageSizes" class="card-image">
    <div class="card-inner">
        <div class="card-inner-hd vr_4">
            <h3 class="hdg hdg_3">{{item.headline}}</h3>
        </div>
        <div class="card-bd vr_8">{{item.summary}}</div>
        <div class="card-inner-cta" v-if="item.readMoreLink">
            <a :href="item.readMoreLink" class="iconCta iconCta">
                <div class="iconCta-text">{{readMoreCopy}}</div>
                <div class="iconCta-icon">
                    <i class="icon icon_chevron"></i>
                </div>
            </a>
        </div>
    </div>
</div>
</template>

<script>
export default {
  props: ["item", "readMoreCopy"]
};
</script>
